module.exports = __webpack_public_path__ + "img/bg2.0175500e.png";